import React from 'react';
import { motion } from 'framer-motion';
export function Gifting() {
  return <section id="gift" className="py-24 md:py-32 bg-cream" data-id="element-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-29">
        <div className="max-w-4xl mx-auto text-center" data-id="element-30">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-31">
            <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-6" data-id="element-32">
              Some things are better received unexpectedly.
            </h2>
            <p className="font-sans text-lg text-warm-gray mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-33">
              A subscription to Yearn is more than a gift. It's a monthly
              reminder that someone is thinking of them. An act of care that
              arrives in their mailbox, asking for nothing but a quiet moment.
            </p>

            <a href="#" className="inline-flex items-center justify-center px-8 py-3 border border-charcoal text-charcoal rounded-full font-medium transition-all hover:bg-charcoal/5 hover:scale-[1.02] duration-300" data-id="element-34">
              Gift a Letter
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}